import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
// import useStringTransforms from '../../hooks/useStringTransforms';

const useStyles = makeStyles((theme) => ({
  sender: {
    color: theme.palette.primary.light,
    fontSize: 10,
    fontWeight: 900,
  },
  content: {
    whiteSpace: 'pre-wrap',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    wordBreak: 'break-word',
    fontSize: 14,
    fontFamily: 'Avenir Next',
    borderBottom: '1px solid black',
    color: theme.palette.darkGrey.light,
    padding: theme.spacing(0.5, 0),
  },
  info: {
    // fontSize: theme.typography.caption.fontSize,
    fontSize: 14,
    display: 'flex',
    justifyContent: 'flex-end',
    // marginBottom: -theme.spacing(0.5),
    marginTop: theme.spacing(0.5),
    color: theme.palette.common.black,
  },
}));

const DefaultBody = ({ type, content, info }) => {
  const classes = useStyles();
  // const { toTitleCase } = useStringTransforms();
  // If sender is required, add as prop

  return (
    <>
      {/* {type !== 'own' && !!sender && (
        <Typography className={classes.sender}>{toTitleCase(sender)}</Typography>
      )} */}
      <Typography className={classes.content}>{content}</Typography>
      {type !== 'bot' && !!info && (
        <div className={classes.info}>{info}</div>
      )}
    </>
  );
};

DefaultBody.propTypes = {
  type: PropTypes.string.isRequired,
  // sender: PropTypes.string,
  content: PropTypes.string.isRequired,
  info: PropTypes.string,
};

DefaultBody.defaultProps = {
  // sender: undefined,
  info: undefined,
};

export default DefaultBody;
